import React, { useState, useEffect } from "react";
import {
  IconButton,
  Drawer,
  Tabs,
  Tab,
  Box,
  Button,
  MenuItem,
  Typography,
  TableContainer,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Paper
} from "@mui/material";
import { Stack, PrimaryButton, Dropdown, Pivot, PivotItem, TextField } from "@fluentui/react";
// Added by Gauri to fix dropdown position issue on 20 Nov 2025
import { DirectionalHint } from "@fluentui/react";
import axios from "axios";
import RiskOccurrenceDetails from "./RiskOccurrenceDetails";
import RiskMitigation from "./RiskMitigation";
import EarlyWarnings from "./EarlyWarnings";
import ContingencyPlanModal from "./ContingencyPlanModal";
import { toast } from "react-toastify";
import { Table } from "react-bootstrap";
import { Close } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { dataGridCellClassNames } from "@fluentui/react-components";
import CloseIcon from "@mui/icons-material/Close";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DeleteIcon from "@mui/icons-material/Delete";
import GetInitiativeDocumentList from "app/hooks/Editpage/GetInitiativeDocumentList";
import DocumentsComponentA from "./DocumentsComponentA";
import Tooltip from "@mui/material/Tooltip";
import { DatePicker, DayOfWeek } from "@fluentui/react";
import AxiosInstance1 from "app/hooks/AxiosInstance/AxiosInstance1";
// Added by Gauri to show History Tab for Action Item on 04 Nov 2025
import ShowHistoryDrawer from "./ShowHistoryDrawer";

const DropZone = styled(Box)({
  border: "2px dashed #ccc",
  padding: "20px",
  textAlign: "center",
  cursor: "pointer",
  color: "#666",
  borderRadius: "4px",
  marginBottom: "20px"
});

// Passed initiativeDetail to get requestStageId by Gauri on 12 Mar 2025
const ActionDrawer = ({ initiativeDetail, initiativesID, data, open, onClose, setRefetch, refetch, acc, canAdd, canEdit, editActionMode, viewDocPermission }) => {  
  const [selectedKey, setSelectedKey] = useState("details");
  const [priorityOptions, SetPriorityOptions] = useState([]);
  const [assignedToOptions, setAssignedToOptions] = useState([]);
  const [changePriorities, setChangePriorities] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [personResponsibleOptions, setPersonResponsibleOptions] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [access, setAccess] = useState([]);
  const [contingencyPlanData, setContingencyPlanData] = useState([]);
  const [drawerData, setDrawerData] = useState(null);
  const userdata = JSON.parse(sessionStorage.getItem("user"));
  const userID = userdata?.employeeId;
  const [selectedFile, setSelectedFile] = useState(null);
  const [documentList, setDocumentList] = useState([]); // state for documents
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [attach, setAttach] = useState(false); // state for upload drawer
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [description, setDescription] = useState("");
  // Added by Gauri for setting document list on 28 Feb 2025
  const [ActionDocList, setActionDocList] = useState([]);
  const [url, setUrl] = useState("");
  console.log("first1111", data);
  const employeeId = userdata?.employeeId;
  //Added By durgesh dalvi to store prior assignTo data so that suring updation if assign to value changes the
  // mail can be sent
  const [earlierAssignedTo, setEarlierAssignedTo] = useState();

  // Added state for requestStageId by Gauri on 12 Mar 2025
  const [requestStageID, setRequestStageID] = useState(initiativeDetail?.data?.listInitiativeDetailEntity[0].controlValue);
  console.log("requestStageID in ActionDrawer", requestStageID);

  const [refresh, setRefresh] = useState(false);
  const [stageOptions, SetStageOptions] = useState([]);
  const [ActionId, setActionId] = useState("");
  const [formValues, setFormValues] = useState({
    submitterLoginType: "",
    initiativeID: "",
    initiativeTitle: "",
    stage: "",
    actionItem: "",
    submittedOn: "",
    dueDate: "",
    assignedTo: "",
    submitterID: "",
    priorityID: "",
    // Commented and Added by Gauri to set default status as blank on 31 Oct 2025
    // statusID: "2",
    statusID: "",
    actualDueDate: "",
    description: ""
  });

  // useEffect(() => {
  //   if (initiativeDetail?.data?.listInitiativeDetailEntity) {
  //     console.log("Initiative Detail Data:", initiativeDetail?.data?.listInitiativeDetailEntity);
  
  //     const initialData = {};
  //     initiativeDetail.data.listInitiativeDetailEntity.forEach((field) => {
  //       if (field.applicable === 1) {
  //         initialData[field.fieldName] = field.controlValue || "";
  //       }
  //     });
  
  //     console.log("Initial Data for Form:", initialData); // Debugging
  //     setFormDataState(initialData);
  //   } else {
  //     console.log("Initiative detail data is missing or incorrect");
  //   }
  // }, [initiativeDetail]);

  useEffect(() => {
    // Added by Gauri to reset form values when opening in Add mode on 31 Oct 2025
    if (open && !data?.actionID) {
      // Reset form values when opening in Add mode (no actionID)
      setFormValues({
        submitterLoginType: "",
        initiativeID: initiativesID || "",
        initiativeTitle: "",
        stage: "",
        actionItem: "",
        submittedOn: "",
        dueDate: "",
        assignedTo: "",
        submitterID: "",
        priorityID: "",
        statusID: "",
        actualDueDate: "",
        description: ""
      });
      setEarlierAssignedTo(null);
      setSelectedKey("details");
      return;
    }

    const fetchAuditDetails = async () => {
      // Check if auditID and actionID are available
      // if (!data?.actionID) {
      //   console.warn("AuditID or ActionID is missing. Skipping API call.", data);
      //   return;
      // }

      console.log("GetExternalAuditActionitemsDetail API Called");
      try {
        const response = await AxiosInstance1.get(
          `/api/InitiativeDetail/GetInitiativeActioItemsDeatils?ActionItemID=${data?.actionID}`,
          {
            headers: {
              "Content-Type": "application/json",
              // Authorization: `Bearer ${sessionStorage.getItem("access_token")}`
            }
          }
        );

        const result = response?.data?.data?.initiativeActionItemsDetails[0];
        //added by durgesh dalvi
        setEarlierAssignedTo(result?.employeeId);
        //end of added by durgesh dalvi
        console.log("drawerData0000", result);
        setFormValues({
          submitterLoginType: result?.submitterLoginType,
          initiativeID: result?.initiativeID,
          actionID: result?.actionID || "",
          initiativeTitle: result?.initiativeTitle || "",
          stage: result?.requestStageID?.toString() || "",
          actionItem: result?.actionItem || "",
          // Modified by Gauri to fix Due Date issue on 31 Oct 2025
          submittedOn: result?.actionDate ? normalizeDateString(result.actionDate) : "",
          dueDate: result?.expectedEndDate ? normalizeDateString(result.expectedEndDate) : "",
          assignedTo: result?.employeeId || "",
          submitterID: result?.submitterID || "",
          priorityID: result?.priorityID?.toString() || "",
          statusID: result?.statusID?.toString() || "",   // Modified by Gauri to set statusID as blank on 31 Oct 2025
          // Modified by Gauri to fix Due Date issue on 31 Oct 2025
          actualDueDate: result?.actualEndDate ? normalizeDateString(result.actualEndDate) : "",
          description: result?.description || ""
        });
      } catch (error) {
        console.error("Error fetching audit details:", error);
      }
    };
    if (data?.actionID) fetchAuditDetails();
  }, [data, open, initiativesID]);    // Added by Gauri to reset form values when opening in Add mode on 31 Oct 2025

  const handleDownload = (filePath) => {
    // Handle document download logic
    console.log("Downloading", filePath);
  };
  const handleAccessTimeClick = (doc) => {
    // Handle document access time logic
    console.log("Accessing time for doc", doc);
  };

  // Helper function to parse date string without timezone issues
  // Added by Gauri on 31 Oct 2025 to fix backdated date issue
  const parseDateString = (dateString) => {
    if (!dateString) return null;
    
    // If already a Date object, return it
    if (dateString instanceof Date) {
      return isNaN(dateString.getTime()) ? null : dateString;
    }
    
    // If it's a string, extract just the date part (yyyy-MM-dd)
    if (typeof dateString === 'string') {
      // Handle ISO format with time: "2025-10-31T00:00:00" or "2025-10-31T10:24:27.327"
      const dateOnly = dateString.split('T')[0].split(' ')[0];
      
      // Check if it matches yyyy-MM-dd format
      if (dateOnly.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const [year, month, day] = dateOnly.split('-');
        // Create date in local timezone to avoid UTC conversion issues
        const localDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        return isNaN(localDate.getTime()) ? null : localDate;
      }
      
      // For other formats, try standard Date parsing
      const date = new Date(dateString);
      if (!isNaN(date.getTime())) {
        // If valid, extract just the date part to avoid timezone issues
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        return new Date(year, month, day);
      }
    }
    
    return null;
  };

  // Helper function to normalize date string to yyyy-MM-dd format
  // Added by Gauri on 31 Oct 2025 to ensure consistent date storage
  const normalizeDateString = (dateString) => {
    if (!dateString) return "";
    
    const parsedDate = parseDateString(dateString);
    if (!parsedDate) return "";
    
    // Format as yyyy-MM-dd
    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const day = String(parsedDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Modified by Gauri to fetch Document list on 28 Feb 2025
  const fetchActionDocumentList = async () => {
    const accessToken = sessionStorage.getItem("access_token");
    setActionId(data?.actionID);

    // Fetching document categories
    const response = await AxiosInstance1.get(
      // `${window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1}/api/InitiativeDetail/GetDocCatgoryAndSubCategory?userID=${employeeId}`,
      `/api/InitiativeList/GetActionItemDocumentList?ActionItemId=${data?.actionID}&UserId=${employeeId}`,
      // {
      //   method: "GET",
      //   headers: {
      //     Authorization: `Bearer ${accessToken}`
      //   }
      // }
    );

    if (response.status === 200) {
      const data = response.data;
      // setActionDocList(data.data.listDocumentCategory);
      setActionDocList(data.data.listActionItemDocumentListEntity || []);
      console.log("AI documentCategories", ActionDocList);
      
    } else {
      console.error("Failed to fetch document categories");
    }

    console.log("GetInitiativeDocumentList12", data?.initiativeID);
    // if (data?.initiativeID) {
    // const document = await GetInitiativeDocumentList(data?.initiativeID, employeeId);
    // setDocumentList(document || []);
    // }
  };

  useEffect(() => {
    if (!data?.actionID) return; 
    
    fetchActionDocumentList();
  }, [data?.actionID, open, refresh]);

  useEffect(() => {
    if (open) {
      fetchDropdownData();
      // fetchRiskDetails();
    }
  }, [data]);
  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
    setAttach(false);
  };
  const handleFileUpload = (event) => {
    setSelectedFile(event.target.files[0]);
  };
  const fetchDropdownData = async () => {
    const fields = [
      "riskcategory",
      "assignedToOptions",
      "priorityid",
      "status",
      "wliststage",
      "personfieldnumeric1",
      "actionpriority"
    ];
    const ideaID = drawerData?.ideaID || initiativesID;
    try {
      const fetchData = async (field) => {
        const response = await AxiosInstance1.get(
          `/api/InitiativeDetail/GetDropDownDetails?IdeaId=${ideaID}&userID=${userID}&FieldName=${field}`,
          {
            headers: {
              "Content-Type": "application/json",
              // Authorization: `Bearer ${sessionStorage.getItem("access_token")}`
            }
          }
        );
        return response.data.data.listInitiativeDetailDropDownEntity;
      };
      const results = await Promise.all(fields?.map((field) => fetchData(field)));
      SetPriorityOptions(results[6] || []);
      setAssignedToOptions(results[1] || []);
      setChangePriorities(results[2] || []);
      setStatuses(results[3] || []);
      SetStageOptions(results[4] || []);
      setPersonResponsibleOptions(results[5] || []);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
      toast.error("Failed to fetch dropdown data.");
    }
  };

  // const fetchRiskDetails = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1}/api/InitiativeRisk/GetInitiativeRisksDetails?RiskID=${data.riskID}&UserID=${userID}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${sessionStorage.getItem("access_token")}`
  //         }
  //       }
  //     );

  //     setAccess(response.data.data.listRiskSubtabAccessEntity);
  //     if (response.data.data && response.data.data.listInitiativeRiskDetail.length > 0) {
  //       setDrawerData(response.data.data.listInitiativeRiskDetail[0]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching risk details:", error);
  //     toast.error("Failed to fetch risk details.");
  //   }
  // };
  const uploadFileData = async () => {
    // Validate the URL before proceeding
    // if (!isValidUrl(url)) {
    //   console.error("Invalid URL:", url);
    //   return;
    // }

    // Construct the API URL
    const apiUrl = `/api/FileUpDown/IniAttachURL?Ideaid=${data?.initiativeID}&URL=${encodeURIComponent(
      url
    )}&CategoryID=${category}&SubCategoryID=${subCategory}&Description=${encodeURIComponent(
      description
    )}&UserID=${employeeId}&LoginType=E`;

    try {
      // Perform the fetch request
      const response = await AxiosInstance1.post(apiUrl, {
        // method: "POST", // You can use 'POST' if needed
        // headers: {
        //   Authorization: `Bearer ${sessionStorage.getItem("access_token")}` // Add the token from session storage
        // }
      });

      // Check if the request was successful
      if (response.status === 200) {
        const data = response.data;
        console.log("Response data:", data);
        return data; // Return the fetched data
      } else {
        console.error("Failed to fetch data:", response.statusText);
        return null;
      }
    } catch (error) {
      // Handle any errors that occur during the fetch
      console.error("Error fetching data:", error);
      return null;
    }
  };
  const fetchGraph = async () => {
    if (!formValues?.riskID || !userID) return;

    try {
      const response = await AxiosInstance1.get(
        `/api/InitiativeRisk/GetRiskAnalysisGraph?RiskID=${data.riskID}`,
        {
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${sessionStorage.getItem("access_token")}`
          }
        }
      );

      console.log("graph", response.data.data);
    } catch (error) {
      console.error("Error fetching risk details:", error);
      toast.error("Failed to fetch risk details.");
    }
  };

  const handlePivotChange = (item) => {
    setSelectedKey(item.props.itemKey);
  };

  const close = () => {
    onClose();
    setFormValues({
      initiativeTitle: "",
      stage: "",
      actionItem: "",
      submittedOn: "",
      dueDate: "",
      assignedTo: "",
      submitterID: "",
      priorityID: "",
      // statusID: "2",
      statusID: "",  // Modified by Gauri to set statusID as blank on 31 Oct 2025
      actualDueDate: "",
      description: ""
    });
  };
  const handleUploadClick = async () => {
    const userdata = JSON.parse(sessionStorage.getItem("user"));
    const employeeId = userdata?.employeeId;
    const accessToken = sessionStorage.getItem("access_token");

    // if (!selectedFile || !category) {
    //   alert("Please fill out all fields and select a file.");
    //   return;
    // }

    const formData = new FormData();
    formData.append("formFile", selectedFile, selectedFile.name);

    try {
      const response = await AxiosInstance1.put(
        `/api/FileUpDown/IniDocUpload?IniID=${
          data?.initiativeID
        }&EmpID=${employeeId}&categoryid=${category}&Subcategoryid=${
          subCategory?.trim() === "" ? 0 : subCategory
        }&Description=${description}`,
        formData,
        // {
        //   method: "PUT",
        //   headers: {
        //     Authorization: `Bearer ${accessToken}`
        //   },
        //   body: formData
        // }
      );

      if (response.status === 200) {
        alert("File uploaded successfully.");
        setRefresh(!refresh);
        toggleDrawer();
      } else {
        alert("Failed to upload file. Please try again.");
      }
    } catch (error) {
      console.error("Upload error:", error);
      alert("An error occurred. Please try again.");
    }
  };
  const handleSave = async () => {
    console.log("here");
    console.log("drawerData0000", formValues);
    if (!formValues?.actionItem) {
      toast.error("ActionItem should not be left blank");
      return;
    }
    if (!formValues?.submittedOn) {
      toast.error("Submitted On should not be left blank");
      return;
    }
    if (!formValues?.dueDate) {
      toast.error("Due date should not be left blank");
      return;
    }
    if (!formValues?.assignedTo) {
      toast.error("Assigned To should not be left blank");
      return;
    }
    // Added by Gauri to show alert for Priority on 30 Oct 2025
    if (!formValues?.priorityID) {
      toast.error("Priority should not be left blank");
      return;
    }
    if (!formValues?.statusID) {
      toast.error("Status should not be left blank");
      return;
    }

    // Added by Gauri to check if the due date is less than submitted on date on 07 May 2025
    if (new Date(formValues.submittedOn) > new Date(formValues.dueDate)) {
      const dueDateObj = new Date(formValues.dueDate);
      const submittedOnObj = new Date(formValues.submittedOn);

      // Remove time component from both dates
      dueDateObj.setHours(0, 0, 0, 0);
      submittedOnObj.setHours(0, 0, 0, 0);

      // Now compare the sanitized date-only values
      if (submittedOnObj > dueDateObj) {
        toast.error("The 'Due Date' should not be less than 'Submitted On'");
        return; // Stop execution
      }
    }

    // Prepare the payload
    const dataToSave = {
      submitterLoginType: formValues?.submitterLoginType,
      initiativeID: formValues?.initiativeID,
      actionItemID: formValues?.actionID,
      actionItem: formValues?.actionItem,
      actionDate: new Date(formValues?.submittedOn || Date.now()).toISOString(),
      description: formValues?.description,
      employeeId: formValues?.assignedTo,
      expectedEndDate: new Date(formValues?.dueDate || Date.now()).toISOString(),
      priorityID: Number(formValues?.priorityID),
      statusID: Number(formValues?.statusID),
      // Commented and Added by Gauri to get requestStageId on 12 Mar 2025
      // requestStageID: Number(sessionStorage.getItem("RequestStageID")),
      requestStageID: requestStageID,
      initiativeID: formValues?.initiativeID || sessionStorage.getItem("ideaIdPk"),
      submitterID: userID,
      submitterLoginType: formValues?.submitterLoginType || "E"
    };

    // Determine the API endpoint and method
    const isUpdate = formValues?.actionID && formValues?.actionID > 0;
    console.log("isUpdate", isUpdate, formValues);
    const apiEndpoint = isUpdate
      ? `/api/InitiativeDetail/UpdateInitiativeActioItemsDeatils`
      : `/api/InitiativeDetail/PostInitiativeActioItemsDeatils`;

    const method = isUpdate ? "PUT" : "POST";

    try {
      // Make the API request
      const response = await AxiosInstance1.request({
        method,
        url: apiEndpoint,
        data: dataToSave,
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${sessionStorage.getItem("access_token")}`
        }
      });

      // Check for success in the response
      //Modified by Durgesh Dalvi: added .listEmailResult to properly get the correct value and show toast
      const result = response?.data?.data?.listEmailResult?.[0]?.result;
      const listEmailResult = response?.data?.data?.listEmailResult?.[0];

      const fromEmailID = listEmailResult?.fromEmailID;
      const toEmailID = listEmailResult?.toEmailID;
      const ccEmailID = listEmailResult?.ccEmailID;
      const subject = listEmailResult?.subject;
      const body = listEmailResult?.body;

      if (response.status === 200 && result?.toLowerCase() === "success") {
        if (formValues?.assignedTo != earlierAssignedTo) {
          sendEmail(fromEmailID, toEmailID, ccEmailID, subject, body);
        } else if (method == "POST") {
          sendEmail(fromEmailID, toEmailID, ccEmailID, subject, body);
        }

        const successMessage = isUpdate
          ? "Action item updated successfully!"
          : "Action item saved successfully!";
        toast.success(successMessage); // Show success toast
        setRefetch(!refetch);
        // Close the drawer or reset the form
        onClose();
        setFormValues(null); // Reset form values
      } else {
        // Handle API error messages
        toast.error(result || "Failed to save the action item. Please try again.");
        onClose();
        setFormValues(null);
      }
    } catch (error) {
      // Handle unexpected errors
      console.error("Error saving action item:", error);
      toast.error(
        error.response?.data?.message || "An error occurred while saving the action item."
      );
    }
  };

  //Added By Durgesh Dalvi : to send update after successfull updation when the assignTo value get change
  const sendEmail = async (fromEmailID, toEmailID, ccEmailID, subject, body) => {
    const apiEndPoint = `/api/EmailService/SendMail`;
    //let formattedMessage = message.replace(/\r\n/g, "<br>");
    const mailData = {
      fromAddress: fromEmailID,
      toAddress: toEmailID,
      ccAddress: ccEmailID,
      //subject: encodeURIComponent(subject),
      //body: encodeURIComponent(body),
      subject: subject.replace(/\r\n/g, " "),
      body: body.replace(/\r\n/g, "<br>"),
      isHtml: 1
    };
    console.log("mailData", mailData);
    try {
      const response = await AxiosInstance1.post(apiEndPoint, mailData, {
        // method: "POST", // Use POST to send the data in the body
        // url: apiEndPoint,
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${sessionStorage.getItem("access_token")}`
        },
        // data: mailData // Send mailData in the body of the request
      });

      console.log("Email sent successfully:", response.data);
      toast.success("Email sent successfully!");
    } catch (error) {
      console.error("Error sending email:", error);
      toast.error(error.response?.data?.message || "An error occurred while sending the email.");
    }
  };
  // End Of Added By Durgesh Dalvi

  // Added by Gauri on 20 Nov 2025 - Common calloutProps for all dropdowns
  const commonCalloutProps = {
    // Use bottomAutoEdge which tries to open downward first, then automatically adjusts upward if needed
    directionalHint: DirectionalHint.bottomAutoEdge,
    // Set max height to prevent dropdown from being too large
    calloutMaxHeight: 250,
    // Ensure dropdown stays within viewport bounds
    bounds: typeof window !== 'undefined' ? {
      top: 0,
      left: 0,
      bottom: window.innerHeight,
      right: window.innerWidth
    } : undefined
  };

  console.log("drawerData0000", formValues);
  return (
    <Drawer anchor="right" open={open} onClose={close}>
      <div className="drawer-content p-4" style={{ width: "70vw", padding: "20px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 2,
            backgroundColor: "#f5f5f5", // Light grey background color
            padding: 2, // Optional padding for spacing
            borderRadius: 1 // Optional for rounded corners
          }}
        >
          <h5 className="drawer-title">Action Item Details</h5>
          <IconButton onClick={() => onClose()}>
            <Tooltip title="Close">
              <Close />
            </Tooltip>
          </IconButton>
        </Box>

        <Pivot onLinkClick={handlePivotChange} selectedKey={selectedKey}>
          <PivotItem headerText="Details" itemKey="details">
            <div>
              <Stack horizontal horizontalAlign="end" className="mt-4 mb-4">
                {/* {acc[2]?.access !== 0 && (
                  <PrimaryButton text="Save" className="ms-2" onClick={handleSave} />
                )} */}
                {((!editActionMode && canAdd) || (editActionMode && canEdit)) && (
                  acc[2]?.access !== 0 && (
                  <PrimaryButton text="Save" className="ms-2" onClick={handleSave} />
                ))}
              </Stack>
              <form>
                <Stack tokens={{ childrenGap: 16 }} className="mt-4">
                  <Stack horizontal tokens={{ childrenGap: 16 }} wrap>
                    {formValues?.actionID && (
                      <Stack.Item grow>
                        <TextField
                          label="Initiative Title"
                          value={formValues?.initiativeTitle || ""}
                          onChange={(e, newValue) =>
                            // Modified by Gauri to fix Due Date issue on 31 Oct 2025
                            // setFormValues({ ...formValues, initiativeTitle: newValue })
                            setFormValues((prev) => ({ ...prev, initiativeTitle: newValue }))
                          }
                          styles={{ root: { minWidth: 200 } }}
                          disabled={true}
                        />
                      </Stack.Item>
                    )}
                    {formValues?.actionID && (
                      <Stack.Item grow>
                        {/* Modified by Gauri to fix dropdown position issue on 20 Nov 2025 */}
                        <Dropdown
                          label="Stage"
                          placeholder="Select Stage"
                          defaultSelectedKey={formValues?.stage || ""}
                          options={[
                            { key: "", text: "Select Stage" },
                            ...(stageOptions?.map((item) => ({
                              key: item.id,
                              text: item.name
                            })) || [])
                          ]}
                          onChange={(e, option) =>
                            // Modified by Gauri to fix Due Date issue on 31 Oct 2025
                            setFormValues((prev) => ({ ...prev, stage: option?.key }))
                          }
                          styles={{ root: { minWidth: 200 } }}
                          disabled={true}
                          calloutProps={commonCalloutProps}
                        />
                      </Stack.Item>
                    )}
                    {formValues?.actionID && (
                      <Stack.Item grow>
                        <DatePicker
                          label="Actual End Date"
                          placeholder="Select a date"
                          disabled={true}
                          // value={
                            //   formValues?.actualDueDate ? new Date(formValues.actualDueDate) : null
                            // }
                            // Modified by Gauri to fix Due Date issue on 31 Oct 2025
                          value={parseDateString(formValues?.actualDueDate)}
                          onSelectDate={(date) => {
                            if (date) {
                              // Adjust the date for time zone offset
                              const adjustedDate = new Date(
                                date.getTime() - date.getTimezoneOffset() * 60000
                              );
                              // Modified by Gauri to fix Due Date issue on 31 Oct 2025
                              setFormValues((prev) => ({
                                ...prev,
                                actualDueDate: adjustedDate.toISOString().split("T")[0] // Format as yyyy-MM-dd
                              }));
                            } else {
                              // Modified by Gauri to fix Due Date issue on 31 Oct 2025
                              setFormValues((prev) => ({
                                ...prev,
                                actualDueDate: ""
                              }));
                            }
                          }}
                          styles={{ root: { minWidth: 200 } }}
                        />
                      </Stack.Item>
                    )}
                  </Stack>

                  <Stack horizontal tokens={{ childrenGap: 16 }} wrap>
                    <Stack.Item grow>
                      <TextField
                        label={
                          <span>
                            Action Item <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        value={formValues?.actionItem || ""}
                        onChange={(e, newValue) =>
                          // Modified by Gauri to fix Due Date issue on 31 Oct 2025
                          setFormValues((prev) => ({ ...prev, actionItem: newValue }))
                        }
                        styles={{ root: { minWidth: 200 } }}
                      />
                    </Stack.Item>
                    <Stack.Item grow>
                      <DatePicker
                        label={
                          <span>
                            Submitted On <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        placeholder="Select a date"
                        // Modified by Gauri to fix Due Date issue on 31 Oct 2025
                        // value={formValues?.submittedOn ? new Date(formValues.submittedOn) : null}
                        value={parseDateString(formValues?.submittedOn)}
                        onSelectDate={(date) => {
                          if (date) {
                            // Adjust the date for time zone offset
                            const adjustedDate = new Date(
                              date.getTime() - date.getTimezoneOffset() * 60000
                            );
                            // Modified by Gauri to fix Due Date issue on 31 Oct 2025
                            setFormValues((prev) => ({
                              ...prev,
                              submittedOn: adjustedDate.toISOString().split("T")[0] // Format as yyyy-MM-dd
                            }));
                          } else {
                            // Modified by Gauri to fix Due Date issue on 31 Oct 2025
                            setFormValues((prev) => ({
                              ...prev,
                              submittedOn: ""
                            }));
                          }
                        }}
                        styles={{ root: { minWidth: 200 } }}
                        disabled={formValues?.actionID}
                      />
                    </Stack.Item>
                    <Stack.Item grow>
                      <DatePicker
                        label={
                          <span>
                            Due Date <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        placeholder="Select a date"
                        // Modified by Gauri to fix Due Date issue on 31 Oct 2025
                        // value={formValues?.dueDate ? new Date(formValues.dueDate) : null}
                        value={parseDateString(formValues?.dueDate)}
                        onSelectDate={(date) => {
                          if (date) {
                            // Adjust the date for time zone offset
                            const adjustedDate = new Date(
                              date.getTime() - date.getTimezoneOffset() * 60000
                            );
                            // Modified by Gauri to fix Due Date issue on 31 Oct 2025
                            setFormValues((prev) => ({
                              ...prev,
                              dueDate: adjustedDate.toISOString().split("T")[0] // Format as yyyy-MM-dd
                            }));
                          } else {
                            // Modified by Gauri to fix Due Date issue on 31 Oct 2025
                            setFormValues((prev) => ({
                              ...prev,
                              dueDate: ""
                            }));
                          }
                        }}
                        styles={{ root: { minWidth: 200 } }}
                      />
                    </Stack.Item>
                  </Stack>

                  <Stack horizontal tokens={{ childrenGap: 16 }} wrap>
                    <Stack.Item grow>
                      <Dropdown
                        label={
                          <span>
                            Assigned To <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        placeholder="Select Assigned Person"
                        defaultSelectedKey={
                          formValues?.assignedTo ? String(formValues.assignedTo) : undefined
                        }
                        // Added by Gauri to add aselect text for dropdown on 31 Oct 2025
                        options={[
                          { key: "", text: "Select Assigned To" },
                          ...assignedToOptions.map((item) => ({
                            key: item.id,
                            text: item.name
                          }))
                        ]}
                        onChange={(e, option) =>
                          // Modified by Gauri to fix Due Date issue on 31 Oct 2025
                          setFormValues((prev) => ({ ...prev, assignedTo: option?.key || "" }))
                        }
                        styles={{ root: { minWidth: 200 } }}
                        calloutProps={commonCalloutProps}
                      />
                    </Stack.Item>
                    <Stack.Item grow>
                      <Dropdown
                        // label="Priority"
                        // Added by Gauri to show mandatory field for Priority on 30 Oct 2025
                        label={
                          <span>
                            Priority <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        placeholder="Select Priority"
                        defaultSelectedKey={formValues?.priorityID}
                        // Added by Gauri to add aselect text for dropdown on 31 Oct 2025
                        options={[
                          { key: "", text: "Select Priority" },
                          ...(priorityOptions?.map((item) => ({
                            key: item.id,
                            text: item.name
                          })) || [])
                        ]}
                        onChange={(e, option) =>
                          // Modified by Gauri to fix Due Date issue on 31 Oct 2025
                          setFormValues((prev) => ({ ...prev, priorityID: option?.key || "" }))
                        }
                        styles={{ root: { minWidth: 200 } }}
                        calloutProps={commonCalloutProps}
                      />
                    </Stack.Item>
                    <Stack.Item grow>
                      <Dropdown
                        label={
                          <span>
                            Status <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        placeholder="Select Status"
                        defaultSelectedKey={formValues?.statusID}
                        // Added by Gauri to add aselect text for dropdown on 31 Oct 2025
                        options={[
                          { key: "", text: "Select Status" },
                          ...(statuses?.map((item) => ({
                            key: item.id,
                            text: item.name
                          })) || [])
                        ]}
                        onChange={(e, option) =>
                          // Modified by Gauri to fix Due Date issue on 31 Oct 2025
                          setFormValues((prev) => ({ ...prev, statusID: option?.key || "" }))
                        }
                        styles={{ root: { minWidth: 200 } }}
                        calloutProps={commonCalloutProps}
                        //disabled={!formValues?.actionID}
                        disabled={false}
                      />
                    </Stack.Item>
                  </Stack>
                  <Stack horizontal tokens={{ childrenGap: 16 }} wrap></Stack>
                  <Stack.Item grow>
                    <TextField
                      label="Description"
                      value={formValues?.description || ""}
                      onChange={(e, newValue) =>
                        // Modified by Gauri to fix Due Date issue on 31 Oct 2025
                        setFormValues((prev) => ({ ...prev, description: newValue }))
                      }
                      multiline
                      rows={4}
                      styles={{
                        root: {
                          width: "100%",
                          maxWidth: 420
                        }
                      }}
                    />
                  </Stack.Item>
                </Stack>
              </form>
            </div>
          </PivotItem>
          {formValues?.actionID && (
            <PivotItem headerText="Document Upload" itemKey="upload">
              <DocumentsComponentA
                setRefresh={setRefresh}
                // initiativeDocument={documentList}
                initiativeDocument={ActionDocList}
                fetchActionDocumentList={fetchActionDocumentList} 
                initiativesID={formValues?.ideaID || initiativesID}
                actionID={ActionId}
                acc={acc}
                viewDocPermission={viewDocPermission}
              />
            </PivotItem>
          )}
          {/* Added by Gauri to show History tab on Action Item on 04 Nov 2025 */}
          {formValues?.actionID && (
            <PivotItem headerText="History" itemKey="history">
              <ShowHistoryDrawer
                uniqueID={ formValues?.actionID || ActionId }
                auditType="ActionItem"
              />
            </PivotItem>
          )}
        </Pivot>
      </div>
    </Drawer>
  );
};

export default ActionDrawer;
